module.exports = __webpack_public_path__ + "static/Gilroy-Heavy-11d2a8760572b53ed65a1d9fe2339701.woff2";